// Platform detection for the Capacitor native shell.
//
// Reads the `window.Capacitor` global the native runtime injects rather
// than importing `@capacitor/core`, so the web/PWA bundle carries no
// Capacitor dependency and this module is safe on every platform.

export function getNativePlatform() {
  const cap = typeof window !== 'undefined' ? window.Capacitor : undefined
  if (!cap) return null
  if (typeof cap.getPlatform === 'function') return cap.getPlatform()
  // Pre-v3 runtimes exposed a plain `platform` property.
  return cap.platform || null
}

// True only inside the iOS App Store binary — the gate for everything
// Apple review constrains: no Stripe checkout surfaces (Guideline 3.1.1),
// no Google-only third-party login (Guideline 4.8), HealthKit sync on.
export function isNativeIOS() {
  return getNativePlatform() === 'ios'
}

// True in a *browser* on an Apple mobile device — iPhone/iPad Safari,
// NOT the Capacitor native shell. This is the "Apple Watch owner on the
// web app" case: HealthKit is out of reach here, so instead of hiding
// Apple Health we point them at the iOS app (/get-the-app). Mutually
// exclusive with isNativeIOS() by construction: any native Capacitor
// platform short-circuits to false before the UA is consulted.
// UA regex mirrors services/pushNotifications.js; the MacIntel +
// maxTouchPoints check catches iPadOS, which masquerades as a Mac.
export function isIOSBrowser() {
  const native = getNativePlatform()
  if (native && native !== 'web') return false
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  if (/iPhone|iPad|iPod/i.test(ua)) return true
  return navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1
}
